import { makeStyles } from "@material-ui/core";
import React from "react";
import { tabletMinWidth } from "./helpers/constants";
import DisclaimerText from "./DisclaimerText";

const useStyles = makeStyles((theme) => ({
  footer: {
    padding: "32px 16px",
    color: theme.palette.gray.main,
    "& .wrapper": {
      alignItems: "center",
      display: "flex",
      flexDirection: "column"
    },
    "& .logo": {
      margin: "32px 0px 0px 0px",
      width: "125px",
      height: "auto"
    },
    "& .symbol": {
      ...theme.typography.symbol
    },
    ...theme.typography.disclaimer,
    backgroundColor: theme.palette.primary.main
  },
  [`@media only screen and (min-width: ${tabletMinWidth}px)`]: {
    root: {
      height: "100vh"
    },
    main: {
      "& .wrapper": {
        justifyContent: "space-between",
        maxWidth: "960px",
        marginLeft: "auto",
        marginRight: "auto"
      }
    },
    footer: {
      "& .logo": {
        margin: "0px 0px 0px 32px"
      },
      "& .wrapper": {
        justifyContent: "space-between",
        maxWidth: "960px",
        flexDirection: "row",
        alignItems: "flex-start",
        marginLeft: "auto",
        marginRight: "auto"
      }
    }
  }
}));

function FooterSection({ disclaimer_processor, logo_url, selected_locale }) {
  const disclaimers_by_paragraph =
    disclaimer_processor?.getDisclaimersByParagraphForCurrentPage?.() || [];
  const classes = useStyles();
  return (
    <footer className={classes.footer}>
      <div className={"wrapper"}>
        <div>
          <DisclaimerText
            selected_locale={selected_locale}
            disclaimers_by_paragraph={disclaimers_by_paragraph}
          />
        </div>
        <div>
          <img className={"logo"} src={logo_url} alt="logo" />
        </div>
      </div>
    </footer>
  );
}

export default FooterSection;
